import getAfsFulfilmentStrings from "../../../getAfsFulfilmentStrings";

const getAfsA11yFulfilmentString = ({ seller }) => {
  const { afs_sold_by, sellerDescription, afs_shipped_by_asos } =
    getAfsFulfilmentStrings({ seller });

  return `${afs_sold_by} ${sellerDescription}${afs_shipped_by_asos}`;
};

export default getAfsA11yFulfilmentString;
